/*
 * @Author: 吴紫阳 764401855@qq.com
 * @Date: 2022-09-26 15:59:22
 * @LastEditors: 吴紫阳 764401855@qq.com
 * @LastEditTime: 2022-10-10 15:28:13
 * @FilePath: \pit-bimwin-react-ui\src\hooks\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useState, useCallback, useEffect } from 'react';
import { Platform as PlatformType } from 'bimwin-api';
import { BtnProps } from '../useBtnOpt';
import { BIM_TYPE } from '../utils/define';
import screenfull from 'screenfull';
interface InitProps {
  isLoading: boolean;
  bimType: string;
  toolbarMenuList: string[];
  firstVisualAngle: unknown;
  cameraData: unknown;
  platform: PlatformType | any;
}
export const useBimwinState = (bimType: string) => {
  const obj: InitProps = {
    isLoading: true,
    bimType: bimType, // 场景类型 2D || 3D
    toolbarMenuList: [],
    firstVisualAngle: {}, // 默认视角
    cameraData: {},
    platform: {},
  };
  const [value, setValue] = useState(obj);
  const [structureData, setstructureData] = useState<any>({ val: 121 });
  useEffect(() => {
    console.log(structureData, 'structureData');
  }, [structureData]);
  console.log(structureData, '重新定义了');
  const [properties, setproperties] = useState<any>({
    value: [],
    dialog: false,
    isShowUI: false,
  });
  const requestAnimationFrame = useCallback(
    (platform: PlatformType) => {
      setValue(pre => {
        pre.firstVisualAngle = platform.bimwin.getCameraData();
        pre.cameraData = platform.bimwin.getCameraData();
        return { ...pre };
      });
    },
    [value]
  );
  /** 主视角 */
  const handleClickMainPerspective = useCallback(() => {
    let bimWin = value.platform.Model.CurrentLayoutViewer2d;
    if (bimWin == null) {
      bimWin = value.platform.bimwin;
    }
    bimWin.setCameraData(value.cameraData, 2);
  }, [value]);
  /** 设置当前为主视图 */
  const handleClickCurrentMainPerspective = useCallback(() => {
    let bimWin = value.platform.Model.CurrentLayoutViewer2d;
    if (bimWin == null) {
      bimWin = value.platform.bimwin;
    }
    if (!bimWin) return;
    value.cameraData = bimWin.getCameraData();
  }, [value]);
  /** 重置主视图 */
  const handleClickResetMainPerspective = () => {
    let bimWin = value.platform.Model.CurrentLayoutViewer2d;
    if (bimWin == null) {
      bimWin = value.platform.bimwin;
    }
    if (!bimWin) return;
    if (value.bimType === BIM_TYPE.TWO_DIMENSIONAL) {
      bimWin.setCameraData(value.firstVisualAngle, 1);
      value.cameraData = value.firstVisualAngle;
    } else {
      bimWin.setCameraData(value.firstVisualAngle, 2);
      value.cameraData = value.firstVisualAngle;
    }
    // this.$PitBimWinMessage("重置成功!");
  };
  /** 全屏 */
  const handleClickFullScreen = (
    obj: BtnProps,
    dom: any,
    setToolbarMenuList: React.Dispatch<
      React.SetStateAction<BtnProps[][] | undefined>
    >,
    index: number
  ) => {
    // const dom = this.$refs.pitBimWinContainer;
    screenfull.toggle(dom.current);
    screenfull.on('change', () => {
      // obj.title = screenfull.isFullscreen ? '取消全屏' : '全屏';
      // obj.visible = screenfull.isFullscreen;
      setToolbarMenuList(pre => {
        let getIndex;
        if (pre) {
          getIndex = pre[index].findIndex(item => item.id === obj.id);
          pre[index][getIndex].title = screenfull.isFullscreen
            ? '取消全屏'
            : '全屏';
          pre[index][getIndex].visible = screenfull.isFullscreen;
        }
        if (pre) {
          return [...pre];
        } else {
          return pre;
        }
      });
    });
  };

  return {
    bimwinData: value,
    setBimwinData: setValue,
    properties,
    setproperties,
    structureData,
    setstructureData,
    requestAnimationFrame,
    handleClickMainPerspective,
    handleClickCurrentMainPerspective,
    handleClickResetMainPerspective,
    handleClickFullScreen,
  };
};
